<template>
  <main id="modal" class="d-flex align-items-center justify-content-center">
    <slot name="modal"></slot>
  </main>
</template>

<script>
export default {};
</script>

<style scoped>
#modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
}
</style>
